import {
    CLEAR_IMAGES,
    IMAGE,
    IMAGE_ERROR,
    IMAGE_SUCCESS
    
 } from "../constants/imagesConstants";
 
 
 const initialState = {
     loading: false,
     success: false,
     error: '',
     type: '',
     search:'',
     images:[], 
     total: ''
 };
 
 
 function imagesReducer(state = initialState, action) {
     switch (action.type) {
         case IMAGE:
             return Object.assign({}, state, {
                 'loading': true,
                 'success': false,
                 'error': '',
                 'type': action.type
 
             });
         case IMAGE_ERROR:
             return Object.assign({}, state, {
                 'loading': false,
                 'success': false,
                 'error': action,
                 'images': '',
                 'type': action.type
             });
         case IMAGE_SUCCESS:
             return Object.assign({}, state, {
                 'loading': false,
                 'success': true,
                 'error': '',
                 'search':action.data.search,
                 'images':(action.data.search===state.search)? [...state.images, ...action.data.images] : action.data.images,
                 'total':action.data.total,
                 'type': action.type
 
             });
        case CLEAR_IMAGES:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'search':'',
                'images':[],
                'total':0,
                'type': action.type

            });

         default:
             return state;
     }
 };
 
 export default imagesReducer;